import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../useAuth";
import CreateFolderModal from "./CreateFolderModal";
import { useActivity } from "../ActivityContext";
import DriveStats from "./DriveStats";
import { HiOutlinePlusCircle, HiOutlineFolder, HiOutlineDownload, HiOutlineShare, HiOutlineDatabase, HiOutlineTrash, HiX, HiOutlineLockClosed } from "react-icons/hi";
import { AnimatePresence, motion } from "framer-motion";

export default function NavBar({ isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { reportData } = useActivity();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/my/home", icon: <HiOutlineDatabase size={20} /> },
    { name: "Organization", path: "/my/organization", icon: <HiOutlinePlusCircle size={20} /> },
    { name: "Private", path: "/my/private", icon: <HiOutlineLockClosed size={20} /> },
    { name: "Shared", path: "/my/shared", icon: <HiOutlineShare size={20} /> },
    { name: "Activity", path: "/my/activity", icon: <HiOutlineFolder size={20} /> },
    { name: "Trash", path: "/my/trash", icon: <HiOutlineTrash size={20} /> },
  ];

  const handleNavClick = (path) => {
    navigate(path);
    if (window.innerWidth < 1024) {
      setIsOpen(false);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Backdrop */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
            className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[55] lg:hidden"
          />
        )}
      </AnimatePresence>

      <div className={`
        fixed lg:relative inset-y-0 left-0 z-[60] lg:z-auto
        h-full flex flex-col bg-white text-slate-600 border-r border-slate-200/60 w-72 lg:w-64 shrink-0 
        overflow-y-auto fancy-scrollbar transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
      `}>

        {/* Navigation Section */}
        <div className="p-6 pb-2">
          <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between lg:justify-start px-2">
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em]">Navigation</span>
              <button onClick={() => setIsOpen(false)} className="lg:hidden p-2 -mr-2 text-slate-400 hover:text-slate-600 transition-colors">
                <HiX size={20} />
              </button>
            </div>
            <div className="flex flex-col gap-2">
              {navItems
                .filter(item => {
                  if (item.name === "Organization") {
                    return user?.userType === "admin";
                  }
                  return true;
                })
                .map((item) => (
                  <button
                    key={item.name}
                    onClick={() => handleNavClick(item.path)}
                    className={`w-full px-6 py-4 rounded-2xl text-[14px] font-bold transition-all duration-300 text-left flex items-center gap-4 ${isActive(item.path)
                      ? "bg-indigo-600 text-white shadow-lg shadow-indigo-200 scale-[1.02]"
                      : "bg-slate-50 text-slate-500 hover:bg-slate-100/80 hover:text-slate-800"
                      }`}
                  >
                    {item.icon}
                    {item.name}
                  </button>
                ))}
            </div>
          </div>
        </div>

        {/* Workspace Summary Section */}
        {/* {reportData && reportData.reportData && (
          <div className="p-6">
            <div className="flex flex-col gap-6">
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em] px-2">Impact Summary</span>
              <div className="grid grid-cols-1 gap-3">
                {reportData.reportData.slice(0, 4).map((item, idx) => {
                  const icon = getMetricIcon(item.actionType);
                  if (!icon) return null;
                  return (
                    <div key={idx} className="flex items-center justify-between p-3 bg-slate-50 border border-slate-200/40 rounded-xl group hover:border-indigo-100 transition-all">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-white rounded-lg border border-slate-100 shadow-sm transition-transform group-hover:scale-110">
                          {icon}
                        </div>
                        <span className="text-[11px] font-bold text-slate-500 tracking-tight">{getMetricLabel(item.actionType)}</span>
                      </div>
                      <span className="text-[12px] font-black text-slate-900 group-hover:text-indigo-600 transition-colors">{item.count}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )} */}

        <div className="mt-auto p-6 pt-2">
          {user?.storageInfo && (
            <DriveStats
              usedMB={user.storageInfo.totalUsedMB}
              totalGB={Math.round((user.storageInfo.totalUsedMB + user.storageInfo.remainingBytes / (1024 * 1024)) / 1024)}
              percentage={user.storageInfo.usagePercent}
            />
          )}
        </div>

        <CreateFolderModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            console.log("Folder created, refreshing...");
          }}
        />
      </div>
    </>
  );
}
